import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Хүсэлтүүд")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Нийт хүсэлт")
const _hoisted_6 = { class: "card shadow" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Нийт жагсаалт")
  ])
], -1)
const _hoisted_8 = {
  class: "card-body",
  style: {"padding":"20px 0 10px 0"}
}
const _hoisted_9 = { style: {"padding":"0 30px"} }
const _hoisted_10 = {
  style: {"margin-top":"10px"},
  align: "center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_input_number, {
            class: "col-sm-1",
            modelValue: _ctx.pageSize,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
            onChange: _ctx.handleChange,
            min: 1,
            max: 100,
            size: "mini"
          }, null, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_input, {
            "prefix-icon": "el-icon-search",
            modelValue: _ctx.customerSearch,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customerSearch) = $event)),
            size: "mini",
            placeholder: "Хайх утга аа оруулна уу...",
            style: {"float":"right","width":"35%"}
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.selectVal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectVal) = $event)),
            placeholder: "Select",
            size: "mini",
            style: {"float":"right","margin":"0 20px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectData, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.selectVal,
                  label: item.selectLabel,
                  value: item.selectVal
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        true
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: 
            this.tableData
              .filter(data => {
                if (_ctx.selectVal === '*') return data;
                return !this.selectVal || data.status.includes(this.selectVal);
              })
              .filter(
                data =>
                  !this.customerSearch ||
                  data.searchfield1.includes(
                    this.customerSearch.toLowerCase()
                  ) ||
                  data.searchfield2.includes(this.customerSearch.toLowerCase())
              )
              .slice(
                this.pageSize * this.page - this.pageSize,
                this.pageSize * this.page
              )
          ,
              style: {"width":"100%","margin-top":"20px"},
              border: "",
              size: "mini",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "№",
                  width: "60",
                  prop: "id"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төрөл",
                  prop: "type",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үйлдэл",
                  prop: "purpose",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.purpose === "01" ? "Засах" : "Устгах"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төлөв",
                  prop: "statusValue",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үүсгэсэн",
                  prop: "createdby",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Үүсгэсэн огноо",
                  prop: "createddate",
                  formatter: _ctx.$filters.formatDateYMDHMS,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Хянасан",
                  prop: "revisedby",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Хянасан огноо",
                  prop: "reviseddate",
                  formatter: _ctx.$filters.formatDateYMDHMS,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Баталсан",
                  prop: "decidedby",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Баталсан огноо",
                  prop: "decideddate",
                  formatter: _ctx.$filters.formatDateYMDHMS,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Анхны утга",
                  prop: "oldvalue",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Шинэ утга",
                  prop: "newvalue",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Тайлбар",
                  prop: "updatecolumn",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Түлхүүр утга",
                  prop: "keyvalue",
                  sortable: ""
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.loadingtable]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_pagination, {
              layout: "total, prev, pager, next, jumper",
              onCurrentChange: _ctx.handleCurrentChange,
              "page-size": _ctx.pageSize,
              total: this.tableData.length
            }, null, 8, ["onCurrentChange", "page-size", "total"])
          ])
        ])
      ])
    ])
  ], 64))
}